const LiveBadge = () => {
    return (
      <div className="flex items-center bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 w-14 rounded-full">
        <span className="animate-ping h-1.5 w-1.5 rounded-full bg-white opacity-75 mr-1"></span>
        LIVE
      </div>
    );
  };
  
  export default LiveBadge;
  